export default __webpack_public_path__ + "static/media/frg--community-cafe.fde1286b.png";